module.exports = __webpack_public_path__ + "assets/770f4ff5bcf73df8d1db354ff8691328.json";